(function () {
  if (window.__ksTreasureCollection) return;
  window.__ksTreasureCollection = true;

  const EXPIRY_PREFIX = 'expiry-';

  function parseExpiryFromTags(tagsStr) {
    if (!tagsStr) return null;
    const tags = tagsStr.split(',').map((t) => t.trim());
    for (let i = 0; i < tags.length; i += 1) {
      const tag = tags[i];
      if (!tag.startsWith(EXPIRY_PREFIX)) continue;
      const raw = tag.slice(EXPIRY_PREFIX.length);
      // expiry-20260625
      if (/^\d{8}$/.test(raw)) {
        return parseInt(raw, 10);
      }
      // expiry-2026-06-25 (ISO-style, common in Admin)
      const isoMatch = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (isoMatch) {
        return parseInt(`${isoMatch[1]}${isoMatch[2]}${isoMatch[3]}`, 10);
      }
    }
    return null;
  }

  function getProductGridLoop() {
    return (
      document.getElementById('AjaxinateLoop') ||
      document.querySelector('[data-products-grid] .grid') ||
      document.querySelector('.collection__products .grid')
    );
  }

  function getProductTags(el) {
    return el.getAttribute('data-product-tags') || el.dataset.productTags || '';
  }

  function getGridItems() {
    const loop = getProductGridLoop();
    if (!loop) return [];
    return Array.from(loop.querySelectorAll('[data-grid-item]'));
  }

  function initTypeFilters(section) {
    const pillsWrap = section.querySelector('[data-ks-type-pills]');
    const sortSelect = section.querySelector('[data-ks-expiry-sort]');
    if (!pillsWrap) return;

    const handle = section.dataset.collectionHandle;
    const allLabel = section.dataset.allLabel || '全部商品';
    const emojiMap = {};

    section.querySelectorAll('[data-ks-type-emoji]').forEach((el) => {
      const type = el.dataset.ksTypeEmoji;
      const emoji = el.dataset.emoji || '';
      if (type) emojiMap[type] = emoji;
    });

    let activeType = '';
    let defaultOrder = [];

    function applyFilter(type) {
      activeType = type;
      pillsWrap.querySelectorAll('[data-ks-type-pill]').forEach((pill) => {
        pill.classList.toggle('is-active', pill.dataset.type === type);
      });

      getGridItems().forEach((item) => {
        const itemType = item.dataset.productType || '';
        const show = !type || itemType === type;
        item.classList.toggle('ks-treasure-hidden', !show);
      });
    }

    function applyExpirySort(mode) {
      const loop = getProductGridLoop();
      if (!loop) return;

      const items = getGridItems();
      if (mode !== 'expiry') {
        defaultOrder.forEach((node) => loop.appendChild(node));
        applyFilter(activeType);
        return;
      }

      const sorted = items.slice().sort((a, b) => {
        const ea = parseExpiryFromTags(getProductTags(a));
        const eb = parseExpiryFromTags(getProductTags(b));
        if (ea === null && eb === null) return 0;
        if (ea === null) return 1;
        if (eb === null) return -1;
        return ea - eb;
      });

      sorted.forEach((node) => loop.appendChild(node));
      applyFilter(activeType);
    }

    function renderPills(types) {
      pillsWrap.innerHTML = '';

      const allBtn = document.createElement('button');
      allBtn.type = 'button';
      allBtn.className = 'ks-type-filters__pill is-active';
      allBtn.dataset.ksTypePill = '';
      allBtn.dataset.type = '';
      allBtn.textContent = allLabel;
      allBtn.addEventListener('click', () => applyFilter(''));
      pillsWrap.appendChild(allBtn);

      types.forEach((type) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ks-type-filters__pill';
        btn.dataset.ksTypePill = '';
        btn.dataset.type = type;
        const emoji = emojiMap[type] ? `${emojiMap[type]} ` : '';
        btn.textContent = `${emoji}${type}`;
        btn.addEventListener('click', () => applyFilter(type));
        pillsWrap.appendChild(btn);
      });
    }

    function buildFromDom() {
      const types = [];
      const seen = {};
      getGridItems().forEach((item) => {
        const t = item.dataset.productType;
        if (t && !seen[t]) {
          seen[t] = true;
          types.push(t);
        }
      });
      types.sort();
      renderPills(types);
    }

    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        applyExpirySort(sortSelect.value);
      });
      if (sortSelect.value === 'expiry') {
        applyExpirySort('expiry');
      }
    }

    defaultOrder = getGridItems();

    if (!handle) {
      buildFromDom();
      return;
    }

    fetch(`/collections/${handle}/products.json?limit=250`)
      .then((res) => res.json())
      .then((data) => {
        const types = [];
        const seen = {};
        (data.products || []).forEach((p) => {
          const t = p.product_type;
          if (t && !seen[t]) {
            seen[t] = true;
            types.push(t);
          }
        });
        types.sort();
        renderPills(types);
      })
      .catch(() => buildFromDom());
  }

  function initVerticalTicker(section) {
    const track = section.querySelector('[data-ks-ticker-track]');
    const messages = section.querySelectorAll('[data-ks-ticker-message]');
    if (!track || messages.length <= 1) return;

    const height = parseInt(section.dataset.tickerHeight, 10) || 40;
    const speed = parseInt(section.dataset.tickerSpeed, 10) || 4000;
    let index = 0;

    track.style.height = `${height}px`;

    messages.forEach((msg) => {
      msg.style.height = `${height}px`;
    });

    function showNext() {
      index = (index + 1) % messages.length;
      track.style.transform = `translateY(-${index * height}px)`;
    }

    const timer = window.setInterval(showNext, speed);
    section.addEventListener('mouseenter', () => window.clearInterval(timer));
  }

  function initStats(section) {
    const handle = section.dataset.collectionHandle;
    const discountEl = section.querySelector('[data-ks-stat-discount]');
    if (!handle || !discountEl) return;

    fetch(`/collections/${handle}/products.json?limit=250`)
      .then((res) => res.json())
      .then((data) => {
        let lowestTenth = null;
        (data.products || []).forEach((p) => {
          (p.variants || []).forEach((v) => {
            const compare = parseFloat(v.compare_at_price);
            const price = parseFloat(v.price);
            if (!compare || compare <= price) return;
            const tenth = Math.round((price * 10) / compare);
            if (tenth < 1) return;
            if (lowestTenth === null || tenth < lowestTenth) {
              lowestTenth = tenth;
            }
          });
        });
        if (lowestTenth !== null) {
          discountEl.textContent = `${lowestTenth} 折起`;
        }
      })
      .catch(() => {});
  }

  function initSection(section) {
    const type = section.dataset.sectionType;
    if (type === 'ks-collection-type-filters') initTypeFilters(section);
    if (type === 'ks-vertical-ticker') initVerticalTicker(section);
    if (type === 'ks-treasure-stats') initStats(section);
  }

  document.querySelectorAll('[data-ks-treasure-section]').forEach(initSection);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-ks-treasure-section]') || event.target;
    if (section.matches && section.matches('[data-ks-treasure-section]')) {
      initSection(section);
    }
  });
})();
